import React, { useEffect, useMemo } from 'react';
import { useForm } from "react-hook-form";
import JoditEditor from 'jodit-react';

const DynamicForm = ({ selectedTemplates, review, labTemplates, onSubmit, defaultValues = {} }) => {

    const { register, handleSubmit, setValue } = useForm({
        defaultValues
    });

    const config = useMemo(
        () => ({
            readonly: false,
            placeholder: "Start typing...",
            toolbarAdaptive: false,
        }),
        []
    );

    // Register fields manually
    useEffect(() => {
        labTemplates.forEach(template => {
            template?.fields?.forEach(field => {
                const key = String(field.id);
                register(key, { required: false }); // register field once
            });
        });
    }, [register, labTemplates]);

    const handleFormSubmit = (formData) => {
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit(handleFormSubmit)}>

            {selectedTemplates.map((templateId) => {
                const template = labTemplates.find((t) => t?.id === templateId);
                if (!template) return null;

                return (
                    <div key={template.id}>
                        <h3>{template.name}</h3>

                        {template.fields.map((field) => {
                            const key = String(field.id);

                            return (
                                <div key={key} style={{ marginBottom: "20px" }}>
                                    <label>{field.name}</label>

                                    <JoditEditor
                                        config={config}
                                        value={defaultValues[key] || ""}
                                        onBlur={(newContent) => {
                                            setValue(key, newContent); // update RHF state
                                        }}
                                        onChange={() => {}}
                                    />
                                </div>
                            );
                        })}
                    </div>
                );
            })}

            <button className='btn' type="submit">
                {review ? "Update Report" : "Submit Report"}
            </button>
        </form>
    );
};

export default DynamicForm;
